import type { JSX } from 'react';
import { Badge, FormSection, Radio } from '@ksyos/design-system';
import type { BariPreResumeMdoData } from '@common/validation/customControls/bariPre/bariPreResumeMdo/v1/bariPreResumeMdoSchemaV1';
import { MdoReportAdvice } from '@common/customControls/bariatrics';
import { useProcessActivityEditContext } from '@frontend/utils';
import { useGetCaroPatient } from '@frontend/utils/hooks/useGetCaroPatient';
import { RadioGroupFormGroup, TextAreaFormGroup } from '../../processActivityFormGroupFields';
import { AanvullendeConclusies } from '../AanvullendeConclusies';
import { CaroActivatedAccountAlert } from '../CaroActivatedAccountAlert';
import { IndicatiesVoorVerwijzing } from '../IndicatiesVoorVerwijzing';
import { adviceValueIsDisabled } from '../utils';
import { resumeMdoAdviceWithColor } from './bariPreResumeMdoUtils';

export function BariPreResumeMdoEdit(): JSX.Element {
    const { data } = useProcessActivityEditContext<BariPreResumeMdoData>();
    const caroPatient = useGetCaroPatient();

    return (
        <>
            {!caroPatient.isLoading && (
                <CaroActivatedAccountAlert hasActivatedAccount={caroPatient.hasActivatedAccount} />
            )}
            <FormSection title="Conclusie">
                <RadioGroupFormGroup
                    fieldKey="hervatten"
                    isRequired={true}
                    label="Hervatten in zorgpad"
                >
                    {resumeMdoAdviceWithColor.map((item) => (
                        <Radio
                            disabled={adviceValueIsDisabled(item.value, caroPatient)}
                            key={item.value}
                            label={
                                <Badge
                                    color={
                                        !caroPatient.hasActivatedAccount && item.value === MdoReportAdvice.include
                                            ? 'neutral'
                                            : item.color
                                    }
                                    text={item.value}
                                />
                            }
                            value={item.value}
                        />
                    ))}
                </RadioGroupFormGroup>

                <TextAreaFormGroup
                    fieldKey="toelichting"
                    isRequired={true}
                    label="Toelichting"
                    placeholder="Typ je toelichting..."
                />

                {data.hervatten === MdoReportAdvice.include && <AanvullendeConclusies />}
            </FormSection>
            <IndicatiesVoorVerwijzing />
        </>
    );
}
